export function convertLanguages(obj: Record<string, Record<string, string>>): Map<string, Map<string, string>> {
    const result = new Map<string, Map<string, string>>();

    for (const [lang, fields] of Object.entries(obj)) {
        const innerMap = new Map<string, string>();

        for (const [key, value] of Object.entries(fields)) {
            if (value !== undefined && value !== null && value !== '') {
                innerMap.set(key, value);
            }
        }

        if (innerMap.size > 0) {
            result.set(lang, innerMap);
        }
    }

    return result;
}

export function convertLanguagesMap(input: any): Map<string, string> {
    const result = new Map<string, string>();

    // Проверка на null и объект
    if (!input || typeof input !== 'object' || Array.isArray(input)) {
        return result;
    }

    // Перебираем ключи объекта и добавляем их в Map
    for (const [key, value] of Object.entries(input)) {
        if (value !== undefined && value !== null && value !== '') {
            result.set(key, input[key]);
        }
    }

    return result;
}